module.exports = __webpack_public_path__ + "img/cliente.85ca0523.svg";